/**
 * Faucet application ID (mainnet). Single source of truth for balance, claim, donation, creator tools.
 */
export const FAUCET_APP_ID = 3461957850;
